// extracted by mini-css-extract-plugin
module.exports = {"mediumScreen":"992px","smallScreen":"540px"};